const T = (key, label, extra = {}) => ({ key, label, type: "text", ...extra });
const TA = (key, label, extra = {}) => ({ key, label, type: "textarea", ...extra });
const IMG = (key, label) => ({ key, label, type: "image" });
const LIST = (key, label, fields) => ({ key, label, type: "list", fields });
const LINES = (key, label) => ({ key, label, type: "lines" });
const BI = (key, label, type = "text") => [
  { key: `${key}_es`, label: `${label} (ES)`, type },
  { key: `${key}_en`, label: `${label} (EN)`, type },
];

export const SCHEMAS = {
  hero: {
    label: "Hero (portada)",
    fields: [
      T("badge", "Etiqueta superior"),
      TA("title", "Título", { hint: "Encierra palabras entre *asteriscos* para resaltarlas en naranja" }),
      TA("subtitle", "Subtítulo"),
      T("cta_primary", "Botón principal"),
      T("cta_secondary", "Botón secundario"),
      LIST("stats", "Estadísticas", [T("value", "Valor"), T("label", "Texto")]),
      IMG("image", "Imagen (opcional, reemplaza la ventana de código)"),
    ],
    defaults: {
      badge: "// agencia.local — IA + diseño web",
      title: "Tu negocio local, *en el primer lugar* de Google.",
      subtitle: "Creamos sucursales digitales de alto rendimiento con inteligencia artificial. Listas en tiempo récord, optimizadas para vender 24/7.",
      cta_primary: "Quiero mi web profesional",
      cta_secondary: "Agenda una auditoría gratis",
      stats: [
        { value: "72h", label: "Entrega promedio" },
        { value: "x3", label: "Más leads locales" },
        { value: "98", label: "PageSpeed score" },
      ],
      image: "",
    },
  },
  problem: {
    label: "Problema / Solución",
    fields: [
      T("problem_eyebrow", "Problema · etiqueta"),
      TA("problem_title", "Problema · título"),
      TA("problem_text", "Problema · texto"),
      LINES("problem_items", "Problema · puntos (uno por línea)"),
      T("solution_eyebrow", "Solución · etiqueta"),
      TA("solution_title", "Solución · título", { hint: "Usa *asteriscos* para resaltar" }),
      TA("solution_text", "Solución · texto"),
      LINES("solution_items", "Solución · puntos (uno por línea)"),
    ],
    defaults: {
      problem_eyebrow: "// problema.actual",
      problem_title: "¿Cansado de perder clientes ante la competencia?",
      problem_text: "El 76% de las búsquedas locales terminan en una visita o llamada en 24 horas. Si no estás en el primer lugar de Google, simplemente no existes para tus futuros clientes.",
      problem_items: ["Tus competidores aparecen primero en Google", "Tu ficha de Maps está vacía o desactualizada", "Inviertes en publicidad sin resultados claros"],
      solution_eyebrow: "// solucion.divelopers",
      solution_title: "La Solución *<Divelopers>*: Diseño web inteligente y rápido.",
      solution_text: "Construimos tu sucursal digital con tecnología de punta e IA aplicada a contenido, SEO y atención al cliente. Resultados medibles desde la primera semana.",
      solution_items: ["Sitios ultra-rápidos (PageSpeed +95)", "Chat con IA que responde 24/7", "SEO local optimizado para tu ciudad"],
    },
  },
  services: {
    label: "Paquetes / Servicios",
    fields: [
      T("eyebrow", "Etiqueta"),
      TA("title", "Título"),
      TA("subtitle", "Subtítulo"),
      LIST("cards", "Paquetes (máx. 3, el 2º se destaca)", [
        T("title", "Nombre"),
        T("tagline", "Frase corta"),
        TA("desc", "Descripción"),
        { key: "items", label: "Incluye (uno por línea)", type: "lines" },
      ]),
    ],
    defaults: {
      eyebrow: "// 03_servicios",
      title: "Paquetes que se adaptan a tu negocio.",
      subtitle: "Soluciones diseñadas para PYMES locales que quieren resultados reales, sin perder semanas en juntas.",
      cards: [
        { title: "Landing Page", tagline: "Ideal para campañas rápidas", desc: "Una página enfocada 100% en conversión. Lista en 72 horas.", items: ["Diseño a medida en Tailwind", "Formulario + WhatsApp", "Pixel & analítica", "Hosting el primer año"] },
        { title: "Sitio Corporativo", tagline: "Tu sucursal digital completa", desc: "Multi-página con catálogo, blog y secciones para escalar.", items: ["Hasta 8 secciones", "Catálogo de productos", "Blog con SEO", "Integración con CRM"] },
        { title: "Optimización Local", tagline: "Domina Google Maps", desc: "Posicionamos tu negocio en el top 3 del map pack local.", items: ["Ficha Google Business", "Citaciones locales", "Reseñas automatizadas", "Schema LocalBusiness"] },
      ],
    },
  },
  software: {
    label: "Software a Medida",
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título", { hint: "Usa *asteriscos* para resaltar" }), TA("subtitle", "Subtítulo")],
    defaults: {
      eyebrow: "// 04_software.a_medida",
      title: "Software a Medida *(Sistemas y MVPs)*",
      subtitle: "Soluciones potentes diseñadas para automatizar procesos y escalar tu negocio.",
    },
  },
  cases: {
    label: "Casos de Éxito",
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título", { hint: "Usa *asteriscos* para resaltar" }), TA("subtitle", "Subtítulo")],
    defaults: {
      eyebrow: "// 05_casos.de_exito",
      title: "Proyectos que ya están *generando dinero*.",
      subtitle: "No vendemos teoría. Estos son sistemas reales operando con clientes reales — con métricas que puedes auditar.",
    },
  },
  quoter: {
    label: "Cotizador",
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título", { hint: "Usa *asteriscos* para resaltar" }), TA("subtitle", "Subtítulo")],
    defaults: {
      eyebrow: "// 04_cotizador.interactivo",
      title: "Calcula tu inversión en segundos.",
      subtitle: "Selecciona lo que necesitas y obtén un presupuesto estimado al instante. Sin sorpresas, sin letra chica.",
    },
  },
  booking: {
    label: "Agenda (Calendly)",
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título", { hint: "Usa *asteriscos* para resaltar" }), TA("subtitle", "Subtítulo")],
    defaults: {
      eyebrow: "// 05_agenda.gratuita",
      title: "Auditoría gratuita de *15 minutos*.",
      subtitle: "Te llamamos por video, revisamos tu presencia digital actual y te entregamos un plan accionable. Sin compromiso.",
    },
  },
  p_hero: {
    label: "Portafolio · Presentación",
    fields: [...BI("intro", "Introducción", "textarea"), ...BI("location", "Ubicación"), IMG("photo", "Foto de perfil (opcional)")],
    defaults: {
      intro_es: "Diseño y construyo sistemas backend robustos, escalables y seguros: APIs de alto tráfico, integraciones B2B y automatización financiera para empresas que no pueden fallar.",
      intro_en: "I design and build robust, scalable and secure backend systems: high-traffic APIs, B2B integrations and financial automation for companies that can't afford to fail.",
      location_es: "México · Remoto",
      location_en: "Mexico · Remote",
      photo: "",
    },
  },
  p_terminal: { label: "Portafolio · Terminal API", fields: [], defaults: {} },
  p_skills: {
    label: "Portafolio · Habilidades",
    fields: [...BI("title", "Título")],
    defaults: { title_es: "Habilidades clave", title_en: "Key skills" },
  },
  p_projects: {
    label: "Portafolio · Proyectos",
    fields: [...BI("title", "Título")],
    defaults: { title_es: "Proyectos Enterprise", title_en: "Enterprise Projects" },
  },
  p_contact: {
    label: "Portafolio · Formulario de contacto",
    fields: [...BI("title", "Título"), ...BI("subtitle", "Subtítulo", "textarea")],
    defaults: {
      title_es: "¿Tienes una oportunidad?",
      title_en: "Have an opportunity?",
      subtitle_es: "Cuéntame sobre tu empresa o proyecto y te respondo en menos de 24 horas.",
      subtitle_en: "Tell me about your company or project and I'll reply within 24 hours.",
    },
  },
  text_image: {
    label: "Texto con imagen",
    custom: true,
    fields: [
      T("eyebrow", "Etiqueta"),
      TA("title", "Título", { hint: "Usa *asteriscos* para resaltar" }),
      TA("body", "Texto"),
      IMG("image", "Imagen"),
      { key: "image_side", label: "Posición de la imagen", type: "select", options: [{ value: "right", label: "Derecha" }, { value: "left", label: "Izquierda" }] },
      T("button_label", "Texto del botón (opcional)"),
      T("button_url", "Enlace del botón"),
    ],
    defaults: { eyebrow: "// nueva.seccion", title: "Un título que *vende*", body: "Describe aquí tu propuesta de valor.", image: "", image_side: "right", button_label: "", button_url: "" },
  },
  cards: {
    label: "Tarjetas / Beneficios",
    custom: true,
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título"), TA("subtitle", "Subtítulo"), LIST("items", "Tarjetas", [T("title", "Título"), TA("description", "Descripción")])],
    defaults: {
      eyebrow: "// beneficios",
      title: "¿Por qué elegirnos?",
      subtitle: "",
      items: [
        { title: "Rápido", description: "Entregamos en días, no meses." },
        { title: "Medible", description: "Resultados que puedes auditar." },
        { title: "Soporte", description: "Te acompañamos después del lanzamiento." },
      ],
    },
  },
  gallery: {
    label: "Galería de imágenes",
    custom: true,
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título"), TA("subtitle", "Subtítulo"), LIST("images", "Imágenes", [IMG("url", "Imagen"), T("caption", "Pie de foto")])],
    defaults: { eyebrow: "// galeria", title: "Nuestro trabajo", subtitle: "", images: [] },
  },
  testimonials: {
    label: "Testimonios",
    custom: true,
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título"), LIST("items", "Testimonios", [T("name", "Nombre"), T("role", "Cargo / Empresa"), IMG("photo", "Foto"), TA("quote", "Testimonio")])],
    defaults: {
      eyebrow: "// testimonios",
      title: "Lo que dicen nuestros clientes",
      items: [{ name: "Nombre del cliente", role: "Dueño · Negocio", photo: "", quote: "Escribe aquí el testimonio real de tu cliente." }],
    },
  },
  faq: {
    label: "Preguntas frecuentes",
    custom: true,
    fields: [T("eyebrow", "Etiqueta"), TA("title", "Título"), LIST("items", "Preguntas", [T("question", "Pregunta"), TA("answer", "Respuesta")])],
    defaults: {
      eyebrow: "// faq",
      title: "Preguntas frecuentes",
      items: [{ question: "¿Cuánto tarda mi sitio?", answer: "Entre 7 y 21 días hábiles según el paquete." }],
    },
  },
};

export const CUSTOM_TYPES = Object.keys(SCHEMAS).filter((k) => SCHEMAS[k].custom);

export const withDefaults = (type, content) => ({ ...(SCHEMAS[type]?.defaults || {}), ...(content || {}) });

export const resolveImg = (url) =>
  url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
